export const INITIAL_LANGUAGE: string = 'pl';

export const CBI_INITIAL_LANGUAGE: string = 'en';

export const CBI_SLANG_INITIAL_LANGUAGE: string = 'en-US';

export const AVAILABLE_LANGUAGES = [
  { name:'Polski', value:'pl', code:'PL' },
  { name:'Angielski', value:'en', code:'EN' },
  { name:'Ukraiński', value:'uk', code:'UA' },
];